module.exports = __webpack_public_path__ + "hu.70eee4dd.svg";